<template>
  <Teleport to="body">
    <Transition name="confirm">
      <div v-if="visible" class="confirm-overlay" @click.self="handleCancel">
        <div class="confirm-box">
          <div class="confirm-header">
            <div class="confirm-icon-wrapper">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            </div>
            <h3 class="confirm-title">{{ title }}</h3>
          </div>
          <p class="confirm-message">{{ message }}</p>
          <div class="confirm-actions">
            <button class="confirm-btn confirm-btn-cancel" type="button" @click="handleCancel">取消</button>
            <button class="confirm-btn confirm-btn-ok" type="button" @click="handleConfirm">确定</button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref } from 'vue'

const visible = ref(false)
const title = ref('确认操作')
const message = ref('')
let resolvePromise = null

const confirm = (msg, options = {}) => {
  message.value = msg
  title.value = options.title || '确认操作'
  visible.value = true
  return new Promise(resolve => { resolvePromise = resolve })
}

const handleConfirm = () => {
  visible.value = false
  resolvePromise?.(true)
}

const handleCancel = () => {
  visible.value = false
  resolvePromise?.(false)
}

defineExpose({ confirm })
</script>

<style scoped>
.confirm-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(26, 26, 26, 0.4);
  backdrop-filter: blur(4px);
  z-index: 10001;
}

.confirm-box {
  width: min(420px, 90vw);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.confirm-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 24px 0;
}

.confirm-icon-wrapper {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(212, 145, 10, 0.1);
  color: #d4910a;
  flex-shrink: 0;
}

.confirm-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
}

.confirm-message {
  margin: 12px 24px 0;
  padding: 0;
  font-size: 14px;
  line-height: 1.7;
  color: #666;
}

.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px 24px 24px;
}

.confirm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 9px 20px;
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-btn:active {
  transform: scale(0.97);
}

.confirm-btn-cancel {
  border: 1px solid rgba(26, 26, 26, 0.1);
  background: #fff;
  color: #1a1a1a;
}

.confirm-btn-cancel:hover {
  background: #f5f4f0;
  border-color: rgba(26, 26, 26, 0.15);
}

.confirm-btn-ok {
  background: linear-gradient(135deg, #c0392b 0%, #a93226 100%);
  color: #fff;
}

.confirm-btn-ok:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(192, 57, 43, 0.25);
}

/* Transition */
.confirm-enter-active {
  animation: confirm-in 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.confirm-leave-active {
  animation: confirm-out 0.15s ease-in forwards;
}

@keyframes confirm-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes confirm-out {
  from { opacity: 1; }
  to { opacity: 0; }
}
</style>
